/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcDtccDtcV1AssetDayEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_DTCC_DTC_V1_ASSET_DAY_EVENT_ENTITY_NAME = 'ixc.dtcc.dtc.v1.AssetDayEvent';
export const ixcDtccDtcV1AssetDayEventEntity = new schema.Entity<IxcDtccDtcV1AssetDayEvent>(IXC_DTCC_DTC_V1_ASSET_DAY_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcDtccDtcV1AssetDayEvent) => `${entity.metadata?.eventId}` });

